import { Search, Play } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useRunMatching } from '@/hooks/use-matches';

interface MatchFiltersProps {
  search: string;
  onSearchChange: (value: string) => void;
  minScore: number;
  onMinScoreChange: (value: number) => void;
}

export function MatchFilters({
  search,
  onSearchChange,
  minScore,
  onMinScoreChange
}: MatchFiltersProps) {
  const runMatching = useRunMatching();

  return (
    <div className="flex flex-wrap items-center gap-3">
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <input
          type="text"
          placeholder="Search candidates or assignments..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className="h-9 w-full rounded-md border bg-background pl-9 pr-3 text-sm outline-none focus:ring-1 focus:ring-ring"
        />
      </div>
      <div className="flex items-center gap-2">
        <label className="text-xs text-muted-foreground">Min Score:</label>
        <input
          type="number"
          min={0}
          max={10}
          step={0.5}
          value={minScore}
          onChange={(e) => onMinScoreChange(parseFloat(e.target.value) || 0)}
          className="h-9 w-16 rounded-md border bg-background px-2 text-center text-sm outline-none focus:ring-1 focus:ring-ring"
        />
      </div>
      <Button size="sm" onClick={() => runMatching.mutate({})} disabled={runMatching.isPending}>
        <Play className="mr-1.5 h-3.5 w-3.5" />
        {runMatching.isPending ? 'Running...' : 'Run Matching'}
      </Button>
    </div>
  );
}
